import * as Sentry from "@sentry/react";
import { silentReauth as sharedSilentReauth } from "@dreebit-registry/vsm-microservice-components";
import { localLogout } from "./localLogout";

/**
 * Thin wrapper around the shared silentReauth that adds this app's Sentry
 * instrumentation and its own (IoT-aware) logout. The loop-guard logic itself lives
 * in the shared library.
 */
export const silentReauth = (
    keycloak: import("keycloak-js").KeycloakInstance,
    reason: string,
) =>
    sharedSilentReauth(keycloak, {
        reason,
        logout: localLogout,
        onLoopGuard: ({ reason: guardReason, lastReauthAt, now }) => {
            Sentry.captureMessage(
                "Silent re-auth loop guard triggered, falling back to full logout",
                {
                    level: "warning",
                    tags: { keycloak: "reauth_loop_guard", reason: guardReason },
                    extra: {
                        lastReauthAt: lastReauthAt.toISOString(),
                        now: now.toISOString(),
                    },
                },
            );
        },
        onReauth: ({ reason: breadcrumbReason, redirectUri }) => {
            Sentry.addBreadcrumb({
                category: "keycloak",
                level: "info",
                message: "Silent re-auth via keycloak.login()",
                data: { reason: breadcrumbReason, redirectUri },
            });
        },
    });
